import { GET_TIMETABLES } from "../graphql/queries/timetables";
import { useQuery } from "@apollo/client";

export const useTimetables = () => {
  const { loading, error, data } = useQuery(GET_TIMETABLES);
  return {
    loading,
    data,
    error,
  };
};
